import { HttpClient } from "@angular/common/http";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { LanguageType } from "../../services/external/config/misc";
export class HelpItemComponent {
	constructor() {
	}
	async load(http: HttpClient, dom: DomSanitizer, lang: LanguageType, name: string): Promise<SafeHtml> {
		return new Promise<SafeHtml>((res, rej) => {
			let path = '/assets/i18n/' + LanguageType[lang] + '-' + name + '.html';
			http.get(path, { responseType: "text" }).subscribe(data => {
				res(dom.bypassSecurityTrustHtml(data));
			});
		});
	}
}
